import Grid24 from './Grid24';

export default Grid24;
